export default {"src":"/_next/static/media/x-icon.c74bc55b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};